var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Vue, Component, ProvideReactive } from 'vue-property-decorator';
import ChangeCompanyDialog from './components/ChangeCompanyDialog.vue';
import LoginContentLeft from './components/LoginContentLeft.vue';
import LoginContentRight from './components/LoginContentRight/index.vue';
import { checkInviteCode } from '@views/login/api/auth';
var LoginIndex = /** @class */ (function (_super) {
    __extends(LoginIndex, _super);
    function LoginIndex() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.entryData = {
            showChangeCompanyDialog: false,
            companies: [],
        };
        /* data */
        _this.toPath = ''; // 登录后要跳转到的路径
        _this.companyId = 0; // 管理的公司id
        _this.userMobile = null; // 用户手机号
        _this.userPwd = ''; // 用户密码
        _this.invitePromptMsg = '';
        _this.showInvitePromptModal = false;
        return _this;
    }
    /* methods */
    LoginIndex.prototype.created = function () {
        var query = this.$route.query;
        if (query.invite) {
            this.checkInvite(query.invite);
        }
    };
    LoginIndex.prototype.checkInvite = function (inviteCode) {
        var _this = this;
        checkInviteCode({
            inviteCode: inviteCode,
        }).then(function (_a) {
            var status = _a.status, username = _a.username;
            if (status) {
                var invitePromptMsg = "\u9879\u76EE\u4EBA\u6570\u5DF2\u6EE1\uFF0C\u8BF7\u8054\u7CFB" + username + "\u5347\u7EA7\u7248\u672C";
                return _this.$confirm(invitePromptMsg, '提示', {
                    showCancelButton: false,
                    confirmButtonText: '知道了',
                    center: true,
                    callback: function () { },
                });
            }
        });
    };
    __decorate([
        ProvideReactive('Login')
    ], LoginIndex.prototype, "entryData", void 0);
    LoginIndex = __decorate([
        Component({
            components: {
                ChangeCompanyDialog: ChangeCompanyDialog,
                LoginContentLeft: LoginContentLeft,
                LoginContentRight: LoginContentRight,
            },
        })
    ], LoginIndex);
    return LoginIndex;
}(Vue));
export default LoginIndex;
